<template>
    <div id="hotel">
        <Teaser :background-url="teaser.imageUrl" :gift-box-banner-visible="hotel.giftBoxBannerVisible">
            <DetailsTeaser />
        </Teaser>
        <div class="container main">
            <DetailsSection class="text-center" no-border>
                <h1 v-skeleton="hotelDetails.name" class="hotel-name">{{ hotelDetails.name }}</h1>
                <Classification
                    v-skeleton="hotelDetails.hotelClassification"
                    :hotel-classification="hotelDetails.hotelClassification || {}"
                    class="hotel-classification"
                />
                <FeatureIcons :features="hotel.hotelTags" />
            </DetailsSection>

            <DetailsSection v-if="$getSafe(hotel, 'variants.length')" no-border>
                <template slot="header">
                    {{ $t('HotelDetails.section.products') }}
                </template>
                <HotelOffers :variants="hotel.variants" :hotelWebname="hotelDetails.webname"></HotelOffers>
            </DetailsSection>

            <DetailsSection v-if="hotel.images && hotel.images.length">
                <template slot="header">{{ $t('ProductDetails.section.photos') }}</template>
                <div class="row">
                    <div class="col-sm-8 offset-sm-2">
                        <ImageGallery :images="hotel.images"></ImageGallery>
                    </div>
                </div>
            </DetailsSection>

            <DetailsSection v-if="hotel.description || hotelDetails.latLon">
                <template slot="header">
                    {{ $t('ProductDetails.section.aboutHotelAndRegion') }}
                </template>
                <div class="row">
                    <Description
                        v-if="hotel.description"
                        :description-html="hotel.description"
                        class="col-sm"
                    ></Description>
                    <HotelMap
                        v-if="$getSafe(hotelDetails, 'latLon.length')"
                        :center="hotelDetails.latLon"
                        :zoom="9"
                        :markers="[marker]"
                        class="col-sm"
                    >
                        <template v-slot:popup="slotProps">
                            <h5>{{ slotProps.entry.name }}</h5>
                            <p class="h6">{{ slotProps.entry.street }}</p>
                            <p class="h6">{{ slotProps.entry.zipcode }} {{ slotProps.entry.city }}</p>
                            <div class="text-center">
                                <a class="btn btn-info text-white" :href="slotProps.entry.routeURL" target="_blank">
                                    {{ $t('Map.button.calculateRoute') }}
                                </a>
                            </div>
                        </template>
                    </HotelMap>
                </div>
            </DetailsSection>

            <DetailsSection class="font-larger">
                <template slot="header">
                    {{ $t('HotelAddress.term.provider') }}
                </template>
                <HotelAddress :hotelDetails="hotelDetails"></HotelAddress>
            </DetailsSection>

            <DetailsSection
                v-if="
                    $getSafe(hotel, 'extraServices.length') ||
                    $getSafe(hotel, 'additionalHotelInfos.length') ||
                    $getSafe(hotel, 'facilityTags.length')
                "
                class="font-larger"
            >
                <template slot="header">{{ $t('ProductDetails.section.featuresAndAmenities') }}</template>
                <Facilities
                    :extraServices="hotel.extraServices"
                    :additionalHotelInfos="hotel.additionalHotelInfos"
                    :facilityTags="hotel.facilityTags"
                >
                </Facilities>
            </DetailsSection>

            <DetailsSection class="text-center" no-border v-if="$store.state.ident !== 'www.animod.nl'">
                <template slot="header">{{ $t('ProductDetails.section.social') }}</template>
                <div class="row">
                    <div class="col-sm-8 offset-sm-2">
                        <Share :title="hotelDetails.name" :pinterestImage="$getSafe(hotel, 'pageData.teaserImageUrl')">
                        </Share>
                    </div>
                </div>
            </DetailsSection>
        </div>
    </div>
</template>

<script>
import Teaser from '@/components/teasers/Teaser';
import DetailsTeaser from '@/components/teasers/DetailsTeaser';
import DetailsSection from '@/components/DetailsSection';
import Classification from '@/components/Classification';
import FeatureIcons from '@/components/FeatureIcons';
import HotelOffers from '@/components/hotel/HotelOffers';
import Description from '@/components/Description';
import HotelMap from '@/components/map/HotelMap';
import HotelAddress from '@/components/HotelAddress';
import Facilities from '@/components/Facilities';
import Share from '@/components/Share';
import skeleton from '@/directives/skeleton';

export default {
    name: 'HotelDetailsDesktop',
    directives: {
        skeleton
    },
    components: {
        DetailsTeaser,
        Teaser,
        DetailsSection,
        Classification,
        FeatureIcons,
        HotelOffers,
        ImageGallery: () => import(/* webpackChunkName: "image-gallery" */ '@/components/product/ImageGallery'),
        Description,
        HotelMap,
        HotelAddress,
        Facilities,
        Share
    },
    props: {
        hotel: Object,
        hotelDetails: Object,
        teaser: Object,
        marker: Object
    }
};
</script>

<style scoped lang="scss">
#hotel {
    .main {
        background-color: var(--body-bg);
    }

    .font-larger {
        font-size: 17px;
    }

    .hotel-name,
    .hotel-classification {
        margin-bottom: 20px;
    }

    .hotel-name {
        font-size: 28px;
        line-height: 28px;
        font-weight: 700;
    }

    .hotel-classification {
        justify-content: center;
        font-size: 28px;
        color: var(--body-color);

        ::v-deep > * {
            margin-left: 7px;
            margin-right: 7px;
        }

        ::v-deep .animod-stars,
        ::v-deep .superior {
            font-size: 20px;
        }
    }
}
</style>
